import { queryOptions } from '@tanstack/react-query'

import { getEntityAllDocumentsDownload, getEntityDocument, getEntityDocuments } from './documents.service'

export const entityDocumentsQueryOptions = (entityId: string, manualQuoteID?: string, bookingID?: string) =>
  queryOptions({
    queryKey: ['entityDocuments', entityId, manualQuoteID, bookingID],
    queryFn: async () => getEntityDocuments(entityId, manualQuoteID, bookingID),
  })

export const entityDocumentQueryOptions = (entityId: string, documentId: string, documentName: string) =>
  queryOptions({
    queryKey: ['entityDocument', entityId, documentId, documentName],
    queryFn: async () => getEntityDocument(entityId, documentId, documentName),
  })

export const entityAllDocumentsDownloadQueryOptions = (customerId: string, entityId: string) =>
  queryOptions({
    queryKey: ['entityAllDocumentsDownload', entityId, customerId],
    queryFn: async () => getEntityAllDocumentsDownload(customerId, entityId),
  })
